import { gql, useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { Pack, QueryGetPackForPurchaseArgs } from 'apollo/generated/types';
import getApiLanguage from 'i18n/apiLanguage';

const GET_PACK = gql`
  query getPack($id: ID!, $date: String!, $language: Language) {
    getPackForPurchase(id: $id, date: $date, language: $language) {
      adultValue
      description
      name
      id
      otherValue
      remaining
      status
      activities {
        activityTimes {
          dailyAvailability
          endHour
          id
          remaining
          startHour
          openActivityTimetablesPerDay {
            id
          }
        }
        id
        name
        hasSingleTimetable
      }
    }
  }
`;

const useGetPackQuery = (id: string, date: string, skip?: boolean) => {
  const { i18n } = useTranslation();

  const query = useQuery<{ getPackForPurchase: Pack }, QueryGetPackForPurchaseArgs>(
    GET_PACK,
    {
      variables: { id, date, language: getApiLanguage(i18n.language) },
      skip,
    }
  );
  return query.data?.getPackForPurchase;
};
export default useGetPackQuery;
